<template>
  <div class="score-page">
    <login-after-head></login-after-head>
    <head-nav-bar></head-nav-bar>
    <div class="container score-container">
      <div class="score-breadcrumb">
        <div class="breadcrumb-nav">
          <router-link to="/index">首页</router-link>
          <span> / </span>
          <span>积分商城</span>
        </div>
      </div>
      <div id="member" class="score-layout">
        <side-nav></side-nav>
        <div class="score-column">
          <div ref="scoreToolbar" class="score-toolbar" :class="{ 'is-sticky': isIntegralUser }">
            <div class="score-summary" v-loading="summaryLoading">
              <span>总积分<strong>{{ balance }}</strong></span>
              <span>限制积分<strong>{{ integralLimit }}</strong><em>（仅限品宣物料）</em></span>
              <router-link class="record-link" to="/integralRecord">查看积分明细</router-link>
            </div>
            <div ref="categoryTabs" class="score-tabs" role="group" aria-label="商品分类">
              <button
                v-for="item in categories"
                :key="item.value"
                type="button"
                :class="{ active: floor === item.value }"
                :aria-pressed="floor === item.value"
                @click="changeCategory(item.value)"
              >
                {{ item.label }}
              </button>
            </div>
          </div>
          <main ref="scoreMain" class="score-main">
            <div v-loading="loading && products.length === 0" class="product-grid" :aria-busy="loading">
              <div v-if="!loading && !loadError && products.length === 0" class="empty-state">
                暂无积分商品
              </div>
              <router-link
                v-for="product in products"
                :key="product.id"
                class="product-card"
                :to="{ path: '/scoreDetails', query: { id: product.id } }"
              >
                <div class="product-image-wrap">
                  <img :src="product.image || require('../assets/noll.png')" :alt="product.storeName || '积分商品'">
                  <span v-if="isSeckill(product)" class="seckill-tag">积分秒杀</span>
                  <span v-if="product.isBenefit === 1" class="benefit-tag">品宣商品</span>
                </div>
                <div class="product-name">{{ productName(product) }}</div>
                <div v-if="isSeckill(product)" class="product-price seckill-price">
                  {{ product.storeSeckill.integral || product.integral }} 积分
                  <span>已抢 {{ product.storeSeckill.percent || 0 }}%</span>
                </div>
                <div v-if="isSeckill(product)" class="product-origin-price">
                  {{ product.integral || 0 }} 积分
                </div>
                <div v-else class="product-price">{{ product.integral || 0 }} 积分</div>
              </router-link>
            </div>

            <infinite-list-footer
              :loading="loading"
              :error="loadError"
              :has-more="hasMore"
              :empty="products.length === 0"
              @load="loadMore"
            />
          </main>
        </div>
      </div>
    </div>
    <i-footer></i-footer>
    <fixed-right></fixed-right>
  </div>
</template>

<script>
import { getIntegral, getIntegralLimit, getIntegralProducts } from '@/api/score'
import currentUser from '@/mixins/current-user'

export default {
  name: 'ScoreMall',
  mixins: [currentUser],
  data () {
    return {
      categories: [
        { label: '全部', value: '-1' },
        { label: '办公用品', value: '1001' },
        { label: '家居', value: '1002' },
        { label: '酒类', value: '1003' },
        { label: '服饰', value: '1004' },
        { label: '品宣商品', value: '-2' },
        { label: '其他', value: '999' }
      ],
      floor: '-1',
      page: 1,
      limit: 20,
      products: [],
      hasMore: false,
      loading: false,
      loadError: false,
      productsRequestId: 0,
      balance: 0,
      integralLimit: 0,
      summaryLoading: true
    }
  },
  mounted () {
    this.floor = this.$route.query.type || '-1'
    this.loadSummary()
    this.fetchProducts()
  },
  methods: {
    loadSummary () {
      return Promise.all([getIntegral(), getIntegralLimit()]).then(([balanceRes, limitRes]) => {
        this.balance = Number(balanceRes.data || 0)
        this.integralLimit = Number(limitRes.data || 0)
      }).catch(error => {
        this.$message.warning((error && error.msg) || '积分信息加载失败，请重试')
      }).finally(() => {
        this.summaryLoading = false
      })
    },
    isSeckill (product) {
      return Number(product.isSeckill) === 1 && product.storeSeckill
    },
    productName (product) {
      if (this.isSeckill(product)) {
        return product.storeSeckill.title || product.storeName || '--'
      }
      return product.storeName || '--'
    },
    changeCategory (floor) {
      if (this.floor === floor) return
      const main = this.$refs.scoreMain
      const toolbar = this.isIntegralUser ? this.$refs.scoreToolbar : this.$refs.categoryTabs
      const stickyTop = parseFloat(window.getComputedStyle(toolbar).top) || 0
      const contentTop = main.getBoundingClientRect().top
      const visibleTop = stickyTop + toolbar.getBoundingClientRect().height
      if (contentTop < visibleTop) {
        window.scrollTo(0, Math.max(0, window.pageYOffset + contentTop - visibleTop))
      }
      this.floor = floor
      this.page = 1
      this.products = []
      this.hasMore = false
      this.fetchProducts(true)
    },
    fetchProducts (reset = false) {
      if (this.loading && !reset) return Promise.resolve()
      const requestId = ++this.productsRequestId
      this.loading = true
      this.loadError = false
      const page = this.page
      return getIntegralProducts({
        isIntegral: 1,
        floor: this.floor,
        page,
        limit: this.limit
      }).then(res => {
        if (requestId !== this.productsRequestId) return
        if (res.status !== 200 || !Array.isArray(res.data)) {
          throw new Error(res.msg || '积分商品加载失败，请重试')
        }
        const list = res.data
        this.products = this.products.concat(list)
        this.hasMore = list.length === this.limit
        this.page = page + 1
      }).catch(error => {
        if (requestId !== this.productsRequestId) return
        this.loadError = true
        console.warn('积分商品加载失败', { floor: this.floor, page })
        this.$message.warning((error && (error.msg || error.message)) || '积分商品加载失败，请重试')
      }).finally(() => {
        if (requestId === this.productsRequestId) this.loading = false
      })
    },
    loadMore () {
      if ((!this.hasMore && !this.loadError) || this.loading) return
      return this.fetchProducts()
    }
  }
}
</script>

<style scoped lang="less">
.score-container {
  padding-bottom: 30px;
}
.score-breadcrumb {
  height: 40px;
  display: flex;
  align-items: center;
  color: #999;
  font-size: 13px;
}
.score-breadcrumb a {
  color: #57aca7;
}
.score-layout {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}
.score-column {
  min-width: 0;
  flex: 1;
}

.score-toolbar {
  display: contents;
}
.score-toolbar.is-sticky {
  display: block;
  position: sticky;
  top: 0;
  z-index: 100;
  background: #fff;
}
.score-toolbar.is-sticky .score-tabs {
  position: static;
}
.score-main {
  min-width: 0;
  flex: 1;
  padding: 0 24px 24px;
  background: #fff;
  border: 1px solid #eee;
}
.score-summary {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  min-height: 40px;
  color: #777;
  font-size: 14px;
}
.score-summary > span {
  white-space: nowrap;
}
.score-summary strong {
  margin-left: 6px;
  color: #57aca7;
  font-size: 20px;
  font-weight: 500;
}
.score-summary em {
  color: #999;
  font-size: 12px;
  font-style: normal;
}
.record-link {
  color: #57aca7;
  font-size: 14px;
}
.score-summary .record-link {
  white-space: nowrap;
}
.score-tabs {
  position: sticky;
  // 顶部搜索栏固定高度为 100px，分类栏紧贴其下方。
  top: 100px;
  z-index: 100;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  padding: 8px 24px;
  background: #fff;
  border: 1px solid #eee;
  border-bottom: 0;
}
.score-tabs button {
  min-width: 92px;
  height: 44px;
  padding: 0 16px;
  border: 1px solid #ddd;
  background: #fff;
  color: #666;
  font-size: 14px;
  cursor: pointer;
}
.score-tabs button.active,
.score-tabs button:hover {
  border-color: #57aca7;
  background: #57aca7;
  color: #fff;
}
.score-tabs button:focus-visible {
  outline: 2px solid #367d79;
  outline-offset: 2px;
}
.product-grid {
  min-height: 300px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
}
.product-card {
  display: block;
  padding: 12px;
  border: 1px solid #eee;
  background: #fff;
  transition: border-color .2s;
}
.product-card:hover {
  border-color: #57aca7;
}
.product-image-wrap {
  position: relative;
  height: 210px;
  background: #fafafa;
}
.product-image-wrap img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.seckill-tag,
.benefit-tag {
  position: absolute;
  top: 8px;
  padding: 3px 7px;
  color: #fff;
  font-size: 12px;
}
.seckill-tag {
  left: 8px;
  background: #e43d33;
}
.benefit-tag {
  right: 8px;
  background: #57aca7;
}
.product-name {
  height: 42px;
  margin-top: 14px;
  overflow: hidden;
  color: #333;
  line-height: 21px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.product-price {
  margin-top: 12px;
  color: #57aca7;
  font-size: 16px;
  font-weight: 600;
}
.seckill-price {
  color: #e43d33;
}
.seckill-price span {
  margin-left: 5px;
  font-size: 12px;
  font-weight: normal;
}
.product-origin-price {
  margin-top: 5px;
  color: #999;
  font-size: 12px;
  text-decoration: line-through;
}
.empty-state {
  grid-column: 1 / -1;
  padding: 100px 0;
  color: #999;
  text-align: center;
}
@media (max-width: 1100px) {
  .product-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
</style>
